export const DASHBOARD_REPORT = 'dashboard/report'
